import { render } from "./DiscountOffer.vue?vue&type=template&id=2fbf5194&scoped=true"
import script from "./DiscountOffer.vue?vue&type=script&lang=js"
export * from "./DiscountOffer.vue?vue&type=script&lang=js"

import "./DiscountOffer.vue?vue&type=style&index=0&id=2fbf5194&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fbf5194"]])

export default __exports__